export const PURGE_AUTH = 'logOut';
export const SET_AUTH = 'setUser';
export const SET_USERS = 'setUsers';
export const SET_ROLES = 'setRoles';
export const CLEAR_ROLES = 'clearRoles';
export const CLEAR_USERS = 'clearUsers';
export const SET_ACCESOS = 'setAccesos';
export const CLEAR_ACCESOS = 'clearAccesos';
export const SET_ERROR = 'setError';
export const FETCHING_ACCESOS = 'fetchingAccesos';
export const FETCHED_ACCESOS = 'fetchedAccesos';
export const SENDING_ACCESO = 'sendingAcceso';
export const SUBMITED_ACCESO = 'submitedAcceso';
export const SUBMIT_ACCESO_ERROR = 'submitAccesoError';
export const RESET_SUBMIT_ACCESO_ERRORS = 'resetSubmitAccesoErrors';
export const SUBMITED_RESIDENTE = 'submitedResidente';
export const SUBMIT_RESIDENTE_ERROR = 'submitResidenteError';
export const RESET_RESIDENTE_SUBMIT = 'resetResidenteSubmit';
export const CLEAR_RESIDENTES = 'clearResidentes';
export const SET_RESIDENTES = 'setResidentes';
export const FETCHING_RESIDENTES = 'fetchingResidentes';
export const FETCHED_RESIDENTES = 'fetchedResidentes';
export const SUBMITED_DESARROLLO = 'submitedDesarrollo';
export const SUBMIT_DESARROLLO_ERROR = 'submitDesarrolloError';
export const SENDING_DESARROLLO = 'sendingDesarrollo';
export const RESET_SUBMIT_DESARROLLO_ERRORS = 'resetSubmitDesarrolloErrors';
export const SUBMITED_VIVIENDA = 'submitedVivienda';
export const SUBMIT_VIVIENDA_ERROR = 'submitViviendaError';
export const FETCHING_VIVIENDAS = 'fetchingViviendas';
export const SET_VIVIENDAS = 'setViviendas';
export const FETCHED_VIVIENDAS = 'fetchedViviendas';
export const CLEAR_VIVIENDAS = 'clearViviendas';
export const RESET_VIVIENDA_SUBMIT = 'resetViviendaSubmit';
export const SET_SUBCONDOMINIOS = 'setSubcondominios';
export const SET_DESARROLLOS = 'setDesarrollos';
export const CLEAR_RESIDENT_INFO = 'clearResidentInfo';
export const FETCHING_RESIDENT = 'fetchingResident';
export const FETCHED_RESIDENT = 'fetchedResident';
export const SET_RESIDENT = 'setResident';
export const FETCHING_VIVIENDA = 'fetchingVivienda';
export const FETCHED_VIVIENDA = 'fetchedVivienda';
export const CLEAR_VIVIENDA_INFO = 'clearViviendaInfo';
export const SET_VIVIENDA = 'setvivienda';
export const SUBMITED_RESIDENT_ASOC = 'submitedResidentAsoc';
export const SUBMIT_RESIDENT_ASOC_ERROR = 'submitResidentAsocError';
export const SUBMITING_RESIDENT_ASOC = 'submitingResidentAsoc';
export const RESET_RESIDENT_ASOC_SUBMIT = 'resetResidentAsocSubmit';
export const DELETED_ASOC = 'deletedAsoc';
export const CANCELLING_ACCESO = 'cancellingAcceso';
export const CANCELLED_ACCESO = 'cancelledAcceso';
export const RESET_REVOKE_SUBMIT = 'resetRevokeSubmit';
export const SENT_CANCEL_ACCESO = 'sentCancelAcceso';
export const CLEAR_COLABORADORES = 'clearColaboradores';
export const SET_COLABORADORES = 'setColaboradores';
export const FETCHED_COLABORADORES = 'fetchedColaboradores';
export const FETCHING_COLABORADORES = 'fetchingColaboradores';
export const CLEAR_COLLABORATOR_INFO = 'clearCollaboratorInfo';
export const FETCHING_COLLABORATOR = 'fetchingCollaborator';
export const FETCHED_COLLABORATOR = 'fetchedCollaborator';
export const SET_COLLABORATOR = 'setCollaborator';
export const SUBMITED_COLABORADOR = 'submitedColaborador';
export const SUBMIT_COLABORADOR_ERROR = 'submitColaboradorError';
export const RESET_COLABORADOR_SUBMIT = 'resetColaboradorSubmit';
export const SUBMITTED_FILES = 'submittedFiles';
export const SUBMIT_FILES_ERROR = 'submitFilesError';
export const SUBMITTED_CAPTURES = 'submittedCaptures';
export const SUBMIT_CAPTURES_ERROR = 'submitCapturesError';
export const SUBMITTED_SIGNATURES = 'submittedSignatures';
export const SUBMIT_SIGNATURES_ERROR = 'submitSignaturesError';
export const SUBMITTED_FINGERPRINTERS = 'submittedFingerprinters';
export const SUBMIT_FINGERPRINTERS_ERROR = 'submitFingerprintersError';
export const CLEAR_FINGERPRINTERS = 'clearFingerprinters';
export const CLEAR_CAPTURES = 'clearCaptures';
export const CLEAR_ALERT_DIALOG = 'clearAlertDialog';
export const RESET_COLABORADOR_PROCESSING = 'resetColaboradorProcessing';
export const STARTED_COLABORADOR_PROCESSING = 'startedColaboradorProcessing';
export const RESET_RESIDENTE_PROCESSING = 'resetResidenteProcessing';
export const STARTED_RESIDENTE_PROCESSING = 'startedResidenteProcessing';
export const SUBMITED_RESIDENTE_APPLICATION = 'submitedResidenteApplication';
export const SUBMIT_APPLICATION_RESIDENTE_ERROR = 'submitApplicationResidenteError';
export const SUBMITED_PWD_RESIDENTE_APPLICATION = 'submitedPwdResidenteApplication';
export const SUBMIT_PWD_APPLICATION_RESIDENTE_ERROR = 'submitPwdApplicationResidenteError';
export const SUBMITED_CLOSE_SESSION_RESIDENTE_APPLICATION = 'submitedCloseSessionResidenteApplication';
export const SUBMIT_CLOSE_SESSION_APPLICATION_RESIDENTE_ERROR = 'submitCloseSessionApplicationResidenteError';
export const CLEAR_VEHICULOS = 'clearVehiculos';
export const SET_VEHICULOS = 'setVehiculos';
export const FETCHED_VEHICULOS = 'fetchedVehiculos';
export const FETCHING_VEHICULOS = 'fetchingVehiculos';
export const SUBMITED_VEHICULO = 'submitedVehiculo';
export const SUBMIT_VEHICULO_ERROR = 'submitVehiculoError';
export const RESET_VEHICULO_SUBMIT = 'resetVehiculoSubmit';
export const CLEAR_VEHICULO_INFO = 'clearVehiculoInfo';
export const FETCHING_VEHICULO = 'fetchingVehiculo';
export const FETCHED_VEHICULO = 'fetchedVehiculo';
export const SET_VEHICULO = 'setVehiculo';
export const RESET_VEHICULO_PROCESSING = 'resetVehiculoProcessing';
export const STARTED_VEHICULO_PROCESSING = 'startedVehiculoProcessing';
export const SET_ACCESO_DETALLES = 'setAccesoDetalles';
export const SUBMITED_RESIDENTE_DELETE = 'submitCResidenteDelete';
export const CLEAR_ALERT_DIALOG_APP = 'clearAlertDialogApp';
export const SUBMITED_USUARIO_DELETE = 'submitedUsuarioDelete';
export const RESET_SUBMITED_RESIDENTE_APPLICATION = 'resetSubmitedResidenteApplication';
export const CLEAR_ACCESOS_DETALLES = 'clearAccesosDetalles';
export const SET_COLLABORATOR_CREDENTIAL = 'setCollaboratorCredential';
export const GENERATE_CREDENTIAL = 'generateCredential';
export const CLEAR_COLABORADOR_CREDENCIAL = 'clearColaboradorCredencial';
export const FETCHING_PREREGISTROS = 'fetchingPreregistros';
export const SET_PREREGISTROS = 'setPreregistros';
export const FETCHED_PREREGISTROS = 'fetchedPreregistros';
export const CLEAR_PREREGISTROS = 'clearPreregistros';
export const CLEAR_PREREGISTRO_INFO = 'clearPreregistroInfo';
export const SET_PREREGISTRO = 'setPreregistro';
export const STARTED_PREREGISTRO_PROCESSING = 'startedPreregistroProcessing';
export const RESET_PREREGISTRO_PROCESSING = 'resetPreregistroProcessing';
export const SUBMITED_PREREGISTRO = 'submitedPreregistro';
export const SUBMIT_PREREGISTRO_ERROR = 'submitPreregistroError';
export const RESET_PREREGISTRO_SUBMIT = 'resetPreregistroSubmit';
export const FETCHING_ACCESO_DETALLES = 'fetchingAccesoDetalles';
export const FETCHED_ACCESO_DETALLES = 'fetchedAccesoDetalles';
export const CLEAR_IMAGES = 'clearImages';
export const SET_FRONT_IMAGE = 'setFrontImage';
export const SET_SIDE_IMAGE = 'setSideImage';
export const SET_BACK_IMAGE = 'setBackImage';
export const SET_FACE_IMAGE = 'setFaceImage';
export const SET_CREDENTIAL_IMAGE = 'setCredentialImage';
export const SET_BACK_CREDENTIAL_IMAGE = 'setBackCredentialImage';
export const FETCHING_DOMESTICO = 'fetchingDomestico';
export const FETCHED_DOMESTICO = 'fetchedDomestico';
export const SUBMITED_DOMESTICO = 'submitedDomestico';
export const SUBMIT_DOMESTICO_ERROR = 'submitDomesticoError';
export const RESET_DOMESTICO_SUBMIT = 'resetDomesticoSubmit';
export const RESET_DOMESTICO_PROCESSING = 'resetDomesticoProcessing';
export const STARTED_DOMESTICO_PROCESSING = 'startedDomesticoProcessing';
export const CLEAR_DOMESTICOS = 'clearDomesticos';
export const FETCHED_DOMESTICOS = 'fetchedDomesticos';
export const FETCHING_DOMESTICOS = 'fetchingDomesticos';
export const CLEAR_DOMESTICOS_INFO = 'clearDomesticosInfo';
export const SET_DOMESTICO = 'setDomestico';
export const SUBMITED_DOMESTICOS = 'submitedDomesticos';
export const SUBMIT_DOMESTICOS_ERROR = 'submitDomesticosError';
export const RESET_DOMESTICOS_SUBMIT = 'ResetDomesticosProcessing';
export const RESET_DOMESTICOS_PROCESSING = 'ResetDomesticosProcessing';
export const STARTED_DOMESTICOS_PROCESSING = 'StartedDomesticosProcessing';
export const SHOW_AVISO_PRIVACIDAD = 'showAvisoPrivacidad';
export const CLEAR_MASCOTAS = 'clearMascotas';
export const CLEAR_MASCOTAS_INFO = 'clearMascotasInfo';
export const FETCHED_MASCOTAS = 'fetchedMascotas';
export const FETCHED_MASCOTA = 'fetchedMascota';
export const FETCHING_MASCOTAS = 'fetchingMascotas';
export const FETCHING_MASCOTA = 'fetchingMascota';
export const SET_MASCOTA = 'setMascota';
export const SUBMITED_MASCOTA = 'submitedMascota';
export const SUBMIT_MASCOTA_ERROR = 'submitMascotaError';
export const RESET_MASCOTA_SUBMIT = 'resetMascotaSubmit';
export const RESET_MASCOTA_PROCESSING = 'resetMascotaProcessing';
export const STARTED_MASCOTA_PROCESSING = 'startedMascotaProcessing';
export const SUBMITED_MASCOTA_DELETE = 'submitedMascotaDelete';
export const FETCHING_LICENCIA = 'fetchingLicencia';
export const FETCHED_LICENCIA = 'fetchedLicencia';
export const SUBMITED_LICENCIA = 'submitedLicencia';
export const SUBMIT_LICENCIA_ERROR = 'submitLicenciaError';
export const RESET_LICENCIA_SUBMIT = 'resetLicenciaSubmit';
export const RESET_LICENCIA_PROCESSING = 'resetLiscenciaProcessing';
export const STARTED_LICENCIA_PROCESSING = 'startedLicenciaProcessing';
export const CLEAR_LICENCIAS = 'clearLicencias';
export const FETCHED_LICENCIAS = 'fetchedLicencias';
export const FETCHING_LICENCIAS = 'fetchingLicencias';
export const CLEAR_LICENCIAS_INFO = 'clearLicenciasInfo';
export const SET_LICENCIA = 'setLicencia';
export const SUBMITED_LICENCIA_DELETE = 'submitedLicenciaDelete';
